import { CheckIcon } from "lucide-react";

import { cn } from "@/lib/utils";

type ReferralRewardsCircleTrackerProps = {
  current: number;
  max: number;
};

export const ReferralRewardsCircleTracker = ({
  current,
  max,
}: ReferralRewardsCircleTrackerProps) => {
  const completedSteps = Math.min(Math.max(0, current), max);

  const renderLine = () => (
    <div
      className="absolute top-1/2 h-2 -translate-y-1/2"
      style={{ left: "16px", right: "16px" }}
    >
      <div className="h-2 rounded-full bg-brand-color/20" />
      <div
        className="absolute left-0 top-0 h-2 rounded-full transition-all duration-300"
        style={{
          width: `${(completedSteps / max) * 100}%`,
          background:
            "linear-gradient(to right, rgb(var(--repeatmd-brand-color)) 0%, rgb(var(--repeatmd-brand-color)) 100%)",
        }}
      />
    </div>
  );

  const renderCircles = () => (
    <div className="relative flex justify-between">
      {Array.from({ length: max }, (_, index) => {
        const isCompleted = index + 1 <= completedSteps;
        return (
          <div key={index} className="flex flex-col items-center">
            <div
              className={cn(
                "relative z-0 flex items-center justify-center rounded-full border-2 transition-all duration-300",
                isCompleted
                  ? "border-white bg-brand-color"
                  : "border-brand-color bg-white"
              )}
              style={{ height: "32px", width: "32px" }}
            >
              {completedSteps === 0 ? (
                <span className="text-center text-sm font-semibold text-brand-color">
                  {index + 1}
                </span>
              ) : (
                isCompleted && <CheckIcon className="h-4 w-4 text-white" />
              )}
            </div>
          </div>
        );
      })}
    </div>
  );

  return (
    <div
      className={cn("ReferralRewardsCircleTrackerProps relative mx-auto")}
      data-testid="ReferralRewardsCircleTrackerProps"
    >
      {renderLine()}

      {renderCircles()}
    </div>
  );
};
